
(function loginModuleDefinition() {

    'use strict';

    angular.module('LoginPage', ['ui.router', 'Config', 'Login'])
        .config([
            'configProvider', '$stateProvider',
            function loginConfig(config, $stateProvider) {
                // Se elimino la llamada porque esta pantalla esta deprecada.
            }
        ]);
})();